import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import TrustSection from './components/TrustSection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';
import Reviews from './components/Reviews';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssbuy.wiki';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy.wiki',
  url: siteUrl,
  description: 'O guia mais completo sobre CSSBuy Spreadsheet. Aprenda a comprar da China com organização, segurança e economia usando planilhas inteligentes.',
  inLanguage: 'pt-BR',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CSSBuy.wiki',
  url: siteUrl,
  description: 'Portal de guias e tutoriais sobre CSSBuy Spreadsheet para importação da China com segurança e economia.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <TrustSection />
      <BlogSection />
      <CTASection />
      <Reviews />
      <Footer />
    </main>
  );
}